import { of } from 'rxjs';
import DIContainer from '@components/DependencyInjectionContainer.js';
export function eventContextGet(options) {
    if (!options.records && options.initiator.getSelectedRecords) {
        options.records = options.initiator.getSelectedRecords();
    }
    if (options.record && !options.records) {
        options.records = [options.record];
    }
    const context = { ...{
            refreshInitiator: () => {
                if (typeof context.initiator.refreshData === 'function') {
                    return context.initiator.refreshData({ explicitRefresh: true });
                }
                else if (context.form) {
                    return context.form.refreshData();
                }
                return of(true);
            },
            alert: (options) => {
                return (context.form || DIContainer.getInstance('Application')).alert(options);
            },
            confirm: (options) => {
                return (context.form || DIContainer.getInstance('Application')).confirm(options);
            },
            prompt: (options) => {
                return (context.form || DIContainer.getInstance('Application')).prompt(options);
            }
        },
        ...options };
    if (context.initiator && !context.form) {
        context.form = DIContainer.getInstance('ComponentRegistry').getFormComponentByElement(context.initiator.rootElement);
    }
    return context;
}
